/* Aira Studio - gift options (cart drawer + cart page).
   Event delegation so it keeps working after the cart drawer re-renders.
   Saves values as cart attributes; no styling here. */
(function () {
  if (window.__airaGift) return;
  window.__airaGift = true;

  var timer;
  var pending = null;
  var dirty = false;

  function getRoot(el) {
    return el && el.closest ? el.closest('.aira-gift') : null;
  }

  function save(root) {
    if (!root) return Promise.resolve();
    var check = root.querySelector('input[type="checkbox"]');
    var isGift = !!(check && check.checked);
    var attrs = { 'Is Gift': isGift ? 'Yes' : '' };
    root.querySelectorAll('[data-attr]').forEach(function (el) {
      attrs[el.dataset.attr] = isGift ? el.value.trim() : '';
    });
    var status = root.querySelector('.aira-gift__status');
    if (status) status.textContent = 'Saving…';
    clearTimeout(timer);
    pending = fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) {
        dirty = false;
        if (status) status.textContent = r.ok ? 'Saved' : 'Could not save, please try again';
      })
      .catch(function () {
        if (status) status.textContent = 'Could not save, please try again';
      });
    return pending;
  }

  document.addEventListener('change', function (e) {
    var root = getRoot(e.target);
    if (!root || e.target.type !== 'checkbox') return;
    var fields = root.querySelector('.aira-gift__fields');
    if (fields) fields.hidden = !e.target.checked;
    save(root);
  });

  document.addEventListener('input', function (e) {
    var root = getRoot(e.target);
    if (!root || !e.target.matches('[data-attr]')) return;
    dirty = true;
    clearTimeout(timer);
    timer = setTimeout(function () { save(root); }, 600);
  });

  document.addEventListener('focusout', function (e) {
    var root = getRoot(e.target);
    if (root && e.target.matches('[data-attr]') && dirty) save(root);
  });

  /* Make sure the latest gift details are saved before going to checkout. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn || !dirty) return;
    var scope = btn.closest('.cart-drawer__summary, .cart-summary__inner') || document;
    var root = scope.querySelector('.aira-gift');
    if (!root) return;
    e.preventDefault();
    save(root).then(function () {
      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
    });
  }, true);
})();
